import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import Titlebar from '../../TitleBar';
import { TableBody } from '.';
import { Pagination, SearchTable, TableHeader } from '../../TableTemplate/index';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../../Utils/table';
import { CuttingList, ReturnList } from '../../TitleList';
import { selectCutReturnlist } from '../../Selectors/Master/ItemSelectors';
import { fetchCuttingReturnlist } from '../../../Store/PHPSlice/Cutting/cuttingApi';


const CuttingReturnReg = () => {
    const dispatch = useDispatch();
    const returnlist = useSelector(selectCutReturnlist);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        dispatch(fetchCuttingReturnlist());
    }, [dispatch]);

    const compData = Array.isArray(returnlist.data) ? returnlist?.data?.map((item, index) => (
        {
            serialNumber: index + 1,
            srno: item.ID,
            ctMemo: item.ctMemo,
            empId: item.empId,
            empNm: item.empNm,
            itemId: item.itemId,
            itemNm: item.itemNm,
            totIssqty: item.totIssqty,
            totReturnqty: item.totReturnqty,
            sts: item.sts,
            soId: item.soId,
            sono: item.sono,
            firmId: item?.firmId,
            firmNm: item?.firmNm,
            totdqty: item?.totdqty,
            orderno: item.orderno,
            totusemtr: item?.totusemtr,
            quotNo:item?.quotNo,
        }
    )) : [];



    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };
    const handleChangeCPage = (n) => {
        setCurrentPage(n);
    };
    const handlePrevPage = () => {
        if (currentPage !== firstIndex) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextpage = () => {
        if (currentPage !== lastIndex) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleRecordsPerPageChange = (event) => {

        setRecordsPerPage(parseInt(event.target.value, 10)); // Parse selected value to integer
        setCurrentPage(0); // Reset current page when records per page changes
    };

    const totalCount = compData ? compData.length : 0;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };


    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        item?.ctMemo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.sono?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.empNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.orderno?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.firmNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.itemNm?.toLowerCase().includes(searchTerm.toLowerCase())
    );



    const renderPaginationButtons = () => {
        let start = Math.max(0, currentPage - 10);
        let end = Math.min(npages, start + 9);

        if (end - start < 9) {
            start = Math.max(1, end - 9);
        }

        return numbers.slice(start - 1, end).map((n) => (

            <button key={n} className={`page-link ${currentPage === n ? 'active' : ''}`} onClick={() => handleChangeCPage(n)}>{n}</button>
        ));
    };

    const handleFilterByName = (event) => {
        setPage(0);
        let value = event.target.value.trim();
        setFilterName(event.target.value);

    };
    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),
    });
    // console.log(dataFiltered);
    // const notFound = !dataFiltered.length;

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const displayedData = filteredData?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };


    return (
        <>
            <Titlebar data={CuttingList} />

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Cutting Return Register</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>

                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                totalItems={filteredData?.length}
                            />


                            <TableContainer style={{ marginTop: '2%' }}>
                                <Table>
                                    <TableHeader
                                        headCells={
                                            [
                                                { id: 'srno', label: 'SrNo' },
                                                { id: 'firmNm', label: 'Firm' },
                                                { id: 'ctMemo', label: 'Cutting Memo No.' },
                                                { id: 'sono', label: 'Sale Order No.' },
                                                // { id: 'orderno', label: 'Order No.' },
                                                { id: 'empNm', label: 'Master' },
                                                { id: 'itemNm', label: 'Item' },
                                                { id: 'totIssqty', label: 'Total Issue Qty.' },
                                                { id: 'totReturnqty', label: 'Total Return Qty.' },
                                                { id: 'totdqty', label: 'Total Damage Qty.' },
                                                // { id: 'totusemtr', label: 'Total Used Mtr.' },
                                                { id: '', label: 'Print' },
                                                { id: '', label: 'View' },
                                                { id: '', label: 'Delete' }

                                            ]
                                        }
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>
                                        {displayedData?.map((row) => (
                                            <TableBody
                                                key={row.srno}
                                                id={row.srno}
                                                ctMemo={row.ctMemo}
                                                empNm={row.empNm}
                                                itemNm={row.itemNm}
                                                quotNo={row.quotNo}
                                                itemId={row.itemId}
                                                totIssqty={row.totIssqty}
                                                totReturnqty={row.totReturnqty}
                                                sts={row.sts}
                                                sono={row.sono}
                                                soId={row.soId}
                                                firmId={row.firmId}
                                                firmNm={row.firmNm}
                                                totdqty={row.totdqty}
                                                orderno={row.orderno}
                                                totusemtr={row.totusemtr}
                                                serialNumber={row.serialNumber}
                                                selected={selected.indexOf(row.name) !== -1}
                                                handleClick={(event) => handleClick(event, row.name)}
                                            />
                                        ))}
                                    </tbody>
                                </Table>
                            </TableContainer>


                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default CuttingReturnReg;
